'use strict';

var React = require('react');

var SvgTemplateMajor = function SvgTemplateMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1h-5.5v6h7v-4.5a1.5 1.5 0 0 0-1.5-1.5zm1.5 8h-5v10h3.5a1.5 1.5 0 0 0 1.5-1.5v-8.5zm-18 0h11v10h-9.5a1.5 1.5 0 0 1-1.5-1.5v-8.5zm1.5-8a1.5 1.5 0 0 0-1.5 1.5v4.5h11v-6h-9.5z"
  }));
};

exports.SvgTemplateMajor = SvgTemplateMajor;
